exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "form input.largeText-d736ea4a{font-size:16px}div.logInWith-f27d688d{margin-bottom:20px;text-align:center}.ssos-ff2dec55{width:100px;margin:0px auto 20px auto;display:flex;justify-content:space-between}.ssos-ff2dec55 .fbBtn-c9af6910>*{color:#3B5998}.ssos-ff2dec55>a,.ssos-ff2dec55>span{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"largeText": "largeText-d736ea4a",
	"logInWith": "logInWith-f27d688d",
	"ssos": "ssos-ff2dec55",
	"fbBtn": "fbBtn-c9af6910"
};